import * as React from "react";
import type { SVGProps } from "react";
const SvgCloudAndSun = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9.394 6.574A4.764 4.764 0 0 1 11 5.905V3c0-.55.45-1 1-1s1 .45 1 1v2.905c.579.124 1.12.352 1.6.665l2.05-2.05a.996.996 0 1 1 1.41 1.41l-2.047 2.047c.314.482.545 1.023.67 1.603h2.897c.55 0 1 .45 1 1s-.45 1-1 1h-1.817A5.27 5.27 0 0 1 22 16.74c0 2.9-2.36 5.26-5.26 5.26H6.32C3.94 22 2 20.06 2 17.68a4.328 4.328 0 0 1 4.984-4.27c.135-.385.325-.746.558-1.073a4.732 4.732 0 0 1-.228-.757H4.42c-.55 0-1-.45-1-1s.45-1 1-1h2.897a4.764 4.764 0 0 1 .667-1.596L5.93 5.93a.996.996 0 1 1 1.41-1.41l2.054 2.054Zm2.61 1.216a2.791 2.791 0 0 1 2.786 2.79c0 .521-.137 1.026-.411 1.464l-.022.01a4.316 4.316 0 0 0-5.126-1.127A2.791 2.791 0 0 1 12 7.79h.004ZM6.95 16.16c.13.43.53.7.95.7l-.01.01c.1 0 .2-.02.3-.05.53-.17.82-.73.65-1.26a2.447 2.447 0 0 1-.11-.75.986.986 0 0 0 .009-.163 2.322 2.322 0 0 1 4.032-1.356 5.355 5.355 0 0 0-.331.419.996.996 0 0 0 .24 1.39c.45.32 1.07.21 1.39-.24.62-.86 1.61-1.38 2.67-1.38a3.26 3.26 0 0 1 0 6.52H6.32C5.04 20 4 18.96 4 17.68a2.322 2.322 0 0 1 2.777-2.276c.034.255.092.507.173.756Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCloudAndSun;
